// React&NextJS
import React from 'react'
// 3rd party libraries
import { motion } from 'framer-motion'
import InputMask from 'react-input-mask'
// Styles
import s from '../Authentication.module.scss'
// Components
import { Button } from '../../../core/button/Button'
import { Container } from '../../../core/container/Container'
import { Text } from '../../../core/text/Text'
import { WhiteBox } from '../../../core/whiteBox/WhiteBox'

const RafraenAudkenning = ({
    closeButton = null,
    phone,
    setPhone,
    plausible,
    signUp,
}) => {
    return (
        <motion.div
            initial={{ transform: 'translateY(0%)', opacity: 0 }}
            animate={{
                transform: 'translateY(0%)',
                opacity: 1,
                transition: {
                    delay: 0.2,
                    ease: [0.45, 0, 0.55, 1],
                    duration: 0.5,
                },
            }}
        >
            <Container>
                <WhiteBox className={s.container}>
                    {closeButton}
                    <div>
                        <Text variant="h2">Rafræn auðkenning</Text>
                        <Text variant="p-18">
                            Skráðu þig inn með rafrænum skilríkjum
                        </Text>
                        <InputMask
                            mask="9999999"
                            placeholder="Símanúmer..."
                            // @ts-ignore:next-line
                            maskChar=""
                            value={phone}
                            onChange={(e) => {
                                setPhone(e.currentTarget.value)
                            }}
                            className={s.input}
                            type="text"
                        />
                        <Text variant="p-small" className={s.warning}>
                            Ekki með rafræn skilríki?{' '}
                            <a
                                href="https://innskraning.island.is/?id=minningar"
                                target="_self"
                                onClick={() => {
                                    plausible('auth-islykill-button')
                                }}
                            >
                                Skrá inn með Íslykli
                            </a>
                        </Text>
                    </div>
                    <Button
                        id="authBtn"
                        disabled={phone.length !== 7}
                        onClick={() => {
                            signUp()
                            plausible('auth-rafraenAudkenning-button')
                        }}
                        className={s.button}
                    >
                        Áfram
                    </Button>
                </WhiteBox>
            </Container>
        </motion.div>
    )
}

export default RafraenAudkenning
